import { render, staticRenderFns } from "./DeudaReportPage.vue?vue&type=template&id=6e4bee89&scoped=true"
import script from "./DeudaReportPage.vue?vue&type=script&lang=js"
export * from "./DeudaReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4bee89",
  null
  
)

export default component.exports